import { KeyboardEvent } from 'react';
import { Textfield } from '@panviva/panviva-react-ui';
import { DATE_PRESET_OPTIONS } from '../../../constants/sidekick';
import './dateFilter.scss';

type CustomDateInputProps = {
    value?: string;
    onClick?: () => void;
    onKeyDown?: (e: KeyboardEvent<HTMLElement>) => void;
    onToggle?: () => void;
    isOpen?: boolean;
    displayValue?: string;
};

export const CustomDateInput = ({ value, onClick, onKeyDown, onToggle, isOpen = false, displayValue }: CustomDateInputProps) => {
    const handleClick = () => {
        if (onToggle) {
            onToggle();
            return;
        }
        onClick?.();
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLElement>) => {
        if (
            e.key === 'Enter' &&
            !e.defaultPrevented &&
            !e.altKey &&
            !e.ctrlKey &&
            !e.metaKey &&
            !e.shiftKey
        ) {
            if (onToggle) {
                e.preventDefault();
                e.stopPropagation();
                onToggle();
                return;
            }

            onKeyDown?.(e);
            return;
        }

        onKeyDown?.(e);
    };

    return (
        <Textfield
            label='Select date range'
            icon={isOpen ? 'arrow-dd-up' : 'arrow-dd-down'}
            value={displayValue ?? value}
            onClick={handleClick}
            onClickIcon={handleClick}
            onKeyDown={handleKeyDown}
            readOnly
        />
    );
};

export const CustomDateContainer = ({ className, children, onClickCustomOption }: { className: string; children: any; onClickCustomOption?: (option: string) => void }) => {

    return (
        <div className='custom-date-container'>
            <ul className='custom-date-options'>
                {DATE_PRESET_OPTIONS.map(option => (
                    <li
                        key={option.value}
                        onClick={onClickCustomOption ? () => onClickCustomOption(option.value) : undefined}
                        className="custom-date-item"
                        role={onClickCustomOption ? "button" : undefined}
                        tabIndex={onClickCustomOption ? 0 : undefined}
                        onKeyDown={onClickCustomOption ? (e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                onClickCustomOption(option.value);
                            }
                        } : undefined}
                    >
                        {option.label}
                    </li>
                ))}
            </ul>
            <div className={className}>
                {children}
            </div>
        </div>
    );
};